import { apiClient } from "./api";

class FileService {
  async listFiles(userId) {
    const sessionToken = sessionStorage.getItem('session_token');
    const response = await apiClient.get(`/api/storage/list?userId=${userId}&session_token=${sessionToken}`);
    return response.data;
  }

  async getFile(datasetId, userId) {
    const sessionToken = sessionStorage.getItem('session_token');
    const response = await apiClient.get(
      `/api/storage/file?datasetId=${datasetId}&userId=${userId}&session_token=${sessionToken}`,
    );
    return response.data;
  }

  async uploadFile(content, fileName, userId) {
    const sessionToken = sessionStorage.getItem('session_token');
    const response = await apiClient.post("/api/storage/upload", {
      content,
      fileName,
      userId,
      session_token: sessionToken,
    });
    return response.data;
  }

  async deleteDataset(datasetId, userId) {
    const sessionToken = sessionStorage.getItem('session_token');
    const response = await apiClient.delete(
      `/api/storage/datasets/${datasetId}?userId=${userId}&session_token=${sessionToken}`,
    );
    return response.data;
  }

  async selectDataset(datasetId, userId) {
    const sessionToken = sessionStorage.getItem('session_token');
    const response = await apiClient.post("/api/storage/select", {
      datasetId,
      userId,
      session_token: sessionToken,
    });
    return response.data;
  }

  async getSelectedDataset() {
    const response = await apiClient.get("/api/storage/selected");
    return response.data;
  }
}

const fileService = new FileService();

export default fileService;
